import { formatReadableDate } from '@whistler-ui/k2/helpers';

const firstTitleName = 'Production Readiness Deadline:';
const secondTitleName = 'Certification Test Window:';
const thirdTitleName = 'Service Launch:';

export const PRODUCTION_DEADLINES = {
  ues: [
    {
      // Phase 7
      status: 'CLOSE',
    },
    {
      // Phase 9
      deadline: 'End of ' + formatReadableDate('2026-07-24'),
      testWindow: formatReadableDate('2026-08-01'),
      serviceLaunch: formatReadableDate('2026-12-01'),
    },
    {
      // Phase 10
      deadline: 'End of ' + formatReadableDate('2026-10-31'),
      testWindow: formatReadableDate('2026-11-01'),
      serviceLaunch: formatReadableDate('2027-03-01'),
    },
    {
      // Phase 11
      deadline: 'End of ' + formatReadableDate('2027-03-20'),
      testWindow: formatReadableDate('2027-04-01'),
      serviceLaunch: formatReadableDate('2027-09-01'),
    },
    {
      // Phase 12
      deadline: 'End of ' + formatReadableDate('2027-07-24'),
      testWindow: formatReadableDate('2027-08-01'),
      serviceLaunch: formatReadableDate('2027-12-01'),
    },
  ],
  partner: [
    {
      // Phase 9
      status: 'CLOSE',
    },
    {
      // Phase 10
      deadline: 'End of ' + formatReadableDate('2026-07-24'),
      testWindow: formatReadableDate('2026-08-01'),
      serviceLaunch: formatReadableDate('2026-12-01'),
    },
    {
      // Phase 11
      deadline: 'End of ' + formatReadableDate('2026-11-15'),
      testWindow: formatReadableDate('2026-12-01'),
      serviceLaunch: formatReadableDate('2027-03-01'),
    },
    {
      // Phase 12
      deadline: 'End of ' + formatReadableDate('2027-03-20'),
      testWindow: formatReadableDate('2027-04-01'),
      serviceLaunch: formatReadableDate('2027-06-01'),
    },
    {
      // Phase 13
      deadline: 'End of ' + formatReadableDate('2027-05-20'),
      testWindow: formatReadableDate('2027-06-01'),
      serviceLaunch: formatReadableDate('2027-09-01'),
    },
  ],
} as const;

type ProductionDeadlines = typeof PRODUCTION_DEADLINES;

type TimelineStep = {
  title: string;
  date: string;
};
type TimelinePhase = {
  phase: number;
  status?: string;
  steps?: TimelineStep[];
};

type DeadlineEntry = {
  status?: string;
  nsxDeadline?: string;
  deadline?: string;
  testWindow?: string;
  serviceLaunch?: string;
};

export const generateTimelineDates = (
  productionDeadlines: ProductionDeadlines,
): Record<keyof ProductionDeadlines, TimelinePhase[]> => {
  return Object.fromEntries(
    Object.entries(productionDeadlines).map(([key, deadlines]) => {
      const timeline: TimelinePhase[] = deadlines.map(
        (deadline: DeadlineEntry, index: number) => {
          if ('status' in deadline && deadline.status === 'CLOSE') {
            return { phase: 9, status: 'CLOSED' };
          }

          const steps: TimelineStep[] = [
            deadline.deadline && {
              title: firstTitleName,
              date: deadline.deadline,
            },
            deadline.testWindow && {
              title: secondTitleName,
              date: deadline.testWindow,
            },
            deadline.serviceLaunch && {
              title: thirdTitleName,
              date: deadline.serviceLaunch,
            },
          ].filter((step): step is TimelineStep => Boolean(step));

          return { phase: 9 + index, steps };
        },
      );

      return [key, timeline];
    }),
  ) as Record<keyof ProductionDeadlines, TimelinePhase[]>;
};

export const TIMELINE_DATES = generateTimelineDates(PRODUCTION_DEADLINES);
